/**
 * Get the pagination URL.
 * @param path - The path to the index page.
 * @param page - The current page number.
 * @param perPage - The number of items per page.
 * @returns The pagination URL.
 */
export function getPaginationUrl(
  path: string,
  page: number,
  perPage?: number,
): string {
  const params = new URLSearchParams({
    page: String(page),
  })
  if (perPage != null) {
    params.set("per_page", String(perPage))
  }
  return `${path}?${params.toString()}`
}
